<template>
  <div
    class="language-badge"
    :class="{ small }"
    :aria-label="`Language: ${code}`"
  >
    {{ code }}
  </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  languageCode: { type: String, required: true },
  small: { type: Boolean, default: false },
});

const code = computed(() => props.languageCode.toUpperCase());
</script>

<style lang="less" scoped>
.language-badge {
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  width: 40px;
  height: 40px;
  border: 4px solid @indigo-300;
  border-radius: 50%;
  color: @indigo-500;
  font-size: 16px;
  font-weight: 500;
  line-height: 28px;
  letter-spacing: -0.44px;

  &.small {
    width: 32px;
    height: 32px;
    border-width: 3px;
    font-size: 13px;
  }
}
</style>
